import { styled } from '@mui/material';
import type { JSX } from 'react';

import { colorSystem } from '../../theme';
import { Flexbox } from '../Flexbox';
import { StandardLayoutProps } from '../types';

const Container = styled(Flexbox)(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
}));

export type CardProps = StandardLayoutProps;

export const Card = ({ sx, ...props }: CardProps): JSX.Element => (
    <Container
        {...props}
        sx={[
            {
                flexDirection: 'column',
                gap: '32px',
                border: `1px solid ${colorSystem.neutral[2]}`,
                padding: '32px 24px',
                borderRadius: '8px',
                maxWidth: 400,
            },
            ...(Array.isArray(sx) ? sx : [sx]),
        ]}
    />
);
